module.exports = __webpack_public_path__ + "static/media/general-water-img.0b3b00dc.jpg";